import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=72264a0e&"
import script from "./Versions.vue?vue&type=script&lang=ts&"
export * from "./Versions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports